<div class="document wrap-text edit">
  <div class="icon">
    <svg-icon
      *ngIf="
        mediaStatus === messageMediaStatus.DOWNLOADING ||
        mediaStatus === messageMediaStatus.UPLOADING
      "
      src="./assets/img/close-white.svg"
      [stretch]="true"
      (click)="cancelEvent()"
    >
    </svg-icon>
    <div
      *ngIf="
        (mediaStatus === messageMediaStatus.DOWNLOADING ||
          mediaStatus === messageMediaStatus.UPLOADING) &&
        !percent
      "
      class="loader-spiner"
      (click)="cancelEvent()"
      [ngStyle]="theme"
    ></div>
    <circle-progress
      *ngIf="
        (mediaStatus === messageMediaStatus.DOWNLOADING ||
          mediaStatus === messageMediaStatus.UPLOADING) &&
        percent
      "
      class="loader-progress"
      [radius]="21"
      [percent]="percent"
      [outerStrokeColor]="themeColor"
      (click)="cancelEvent()"
    ></circle-progress>

    <!-- in cse of FAILED and want to redownload or upload -->
    <i
      *ngIf="mediaStatus === messageMediaStatus.UPLOAD_FAILED"
      class="fas fa-long-arrow-alt-up"
      aria-hidden="true"
      (click)="retryEvent()"
    ></i>

    <i
      *ngIf="mediaStatus === messageMediaStatus.DOWNLOAD_FAILED"
      class="fas fa-long-arrow-alt-down"
      aria-hidden="true"
      (click)="retryEvent()"
    ></i>

    <!-- in case of media and isPause -->
    <i
      *ngIf="
        mediaStatus === messageMediaStatus.DOWNLOADED ||
        mediaStatus === messageMediaStatus.UPLOADED
      "
      class="fas fa-file"
      aria-hidden="true"
    ></i>
  </div>
  <div class="document-details">
    <div class="file-name">{{ fileName }}</div>
    <div class="file-size">
      {{ fileSize | fileSize }}
    </div>
  </div>
</div>
